// extracted by mini-css-extract-plugin
export var card = "_mu-1";
export var summary = "_mu-0";
export var unreadDot = "_mu-2";